var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.414,
    height: 11.414,
    viewBox: "0 0 11.414 11.414",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-6.293 -6.293)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,10.707-.707,10,10-.707,10.707,0Z",
    transform: "translate(7 7)",
    fill: "#dfe1e5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5,17.5h-1V7.5H6.5v-1h11Z",
    fill: "#dfe1e5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search-icon.84e8e62f22e95ae3a4b3433109b49741.svg";
export { ForwardRef as ReactComponent };